import axios from "axios";
import Cookies from "js-cookie";
axios.defaults.headers.common['Version']=`5.0.0 Google`
axios.defaults.baseURL = 'https://api.picopool.ir/';
class Axios {
     setAuth=(token)=>{
        axios.defaults.headers.common['Authorization']=`Bearer ${token}`
        Cookies.set('appLoaded', token, { expires: 1})
    }
    logOut=()=>{
        Cookies.remove('appLoaded')
        window.location.href='/'
    }
     defaultHeaders=()=>{
        axios.interceptors.response.use(response => {
            return response;
        }, error => {
            if (error.response.status === 401) {
                alert('AUTH ERROR')
                Cookies.remove('appLoaded')
                window.location.href='/'
            }
            return error;
        });
    }
}
export default Axios